import { Component, createElement } from 'react';
import trackAnalyticEvent from '../utils/trackAnalyticEvent';
import trackNewRelicPageViewName
  from '../utils/trackNewRelicPageViewName';

// From https://github.com/react-ga/react-ga/wiki/React-Router-v4-withTracker#code
export default function(WrappedComponent, staticOptions = {}) {
  const trackPage = (page, options = {}) => {
    trackAnalyticEvent('pageview', { page_path: page, ...staticOptions, ...options });

    if (options.page_title !== undefined) {
      trackNewRelicPageViewName(options.page_title);
    }
  };

  return class WithAnalyticsPageView extends Component {
    instanceReference = null;

    componentDidMount() {
      const page = this.props.location.pathname + this.props.location.search;

      // 1. Allows to return a Promise in the getTrackingOptions function, this
      //    is useful when we must wait for an HTTP request to get the needed
      //    tracking properties (eg. the page title in a theme page).
      Promise.resolve(this.getTrackingOptions())
        .then(options => trackPage(page, options));
    }

    componentDidUpdate(prevProps) {
      // const currentPage = prevProps.location.pathname + prevProps.location.search;
      // const nextPage = this.props.location.pathname + this.props.location.search;
      //
      // if (currentPage !== nextPage) {
      //   // @see 1.
      //   Promise.resolve(this.getTrackingOptions())
      //     .then(options => trackPage(nextPage, options));
      // }
    }

    getTrackingOptions() {
      // noinspection JSUnresolvedVariable
      const trackingOptions = this.instanceReference.getTrackingOptions;

      if (typeof trackingOptions === 'function') {
        return trackingOptions();
      }

      return {};
    }

    render() {
      return createElement(WrappedComponent, {
        ...this.props,
        ref: ref => this.instanceReference = ref,
      });
    }
  };
}
